/**
 * Route subtree mounted at `/w/:slug/feedback` from `App.tsx`. Code-split via
 * `React.lazy` so the feedback bundle stays out of the initial dashboard load.
 * Response-feedback unit PR-C.
 */

import { lazy, Suspense } from "react";
import { Route } from "react-router";

import { RouteFallback } from "../components/route-fallback";

const FeedbackPage = lazy(() =>
  import("./pages/FeedbackPage").then((m) => ({ default: m.FeedbackPage })),
);

export function feedbackRoutes() {
  return (
    <Route
      path="feedback"
      element={
        <Suspense fallback={<RouteFallback />}>
          <FeedbackPage />
        </Suspense>
      }
    />
  );
}
